<template>
  <el-card class="page-container h-full">
    <div ref="formHeightRef">
      <el-form :inline="true" :model="form.keyWord" ref="form" @submit.native.prevent="search">
        <el-form-item label="" prop="keyWord">
          <el-input
            v-model="form.keyWord"
            placeholder="设备名称/编码/消息内容"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="messageType">
          <el-select v-model="form.messageType" clearable placeholder="请选择消息类型">
            <el-option
              v-for="item in messageTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="tableData"
      border
      stripe
      :height="`calc(100vh - 200px - ${formHeight}px)`"
      v-loading="tableLoading"
    >
      <el-table-column label="序号" prop="seqNo" width="60" :align="alignType"></el-table-column>
      <el-table-column label="设备编码" prop="deviceCode" :align="alignType"></el-table-column>
      <el-table-column label="设备名称" prop="deviceName" :align="alignType"></el-table-column>
      <el-table-column label="消息类型" :align="alignType">
        <template slot-scope="{ row }">
          {{ getMessageTypeLabel(row) }}
        </template>
      </el-table-column>
      <el-table-column label="消息内容" prop="message" :align="alignType"></el-table-column>
      <el-table-column label="发送时间" :align="alignType">
        <template slot-scope="{ row }">
          {{ formatDateTime(row) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" :align="alignType"> </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px"
      background
      @size-change="getList"
      @current-change="getList"
      :current-page.sync="initPagination.pageNum"
      :page-size.sync="initPagination.pageSize"
      :total="initPagination.total"
      layout="->,total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>
  </el-card>
</template>

<script>
import tableHeightMixin from '@/mixins/tableHeightMixin'
import { FirefightingMessageApi } from '@wiz-api/iot-device-management'
import FnMixins from '@/assets/js/fnMixins'

const firefightingMessageApi = new FirefightingMessageApi()

export default {
  name: 'CameraList',
  mixins: [tableHeightMixin, FnMixins],
  components: {},
  props: {},
  data() {
    return {
      alignType: 'left',
      form: {
        keyWord: '',
        messageType: '',
      },
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
      messageTypeList: [
        {
          label: '报警消息',
          value: 0,
        },
        {
          label: '系统消息',
          value: 1,
        },
      ],
    }
  },
  computed: {
    getMessageTypeLabel() {
      return (row) => {
        for (let i = 0; i < this.messageTypeList.length; i += 1) {
          if (this.messageTypeList[i].value === row.messageType) {
            return this.messageTypeList[i].label
          }
        }
        return ''
      }
    },
    formatDateTime() {
      return (row) => {
        if (row.sendTime) {
          return this.dayjs(row.sendTime).format('YYYY/MM/DD HH:mm:ss')
        }
        return ''
      }
    },
  },
  methods: {
    formatDate(row, column, cellValue) {
      if (cellValue) return dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss')
      return cellValue
    },
    search() {
      this.initPagination.pageNum = 1
      this.getList()
    },
    reset() {
      this.$refs.form.resetFields()
      this.getList()
    },
    async getList() {
      this.tableLoading = true
      const [err, res] = await firefightingMessageApi.getList({
        keyword: this.form.keyword,
        messageType: this.form.messageType,
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        maxResultCount: this.initPagination.pageSize,
      })
      this.tableLoading = false
      if (!err) {
        this.tableData = res.items || []
        this.initPagination.total = res.totalCount
      }
    },
  },
  async created() {
    this.getList()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
.successTextColor {
  color: var(--tagSuccessText);
}
.infoText {
  color: var(--tagInfoText);
}
</style>
